module.exports = __webpack_public_path__ + "static/img/ywcb.916c186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/ywcb.png
// module id = Orsu
// module chunks = 1